import React from "react";
import styles from "./styles.module.scss";

interface ProgressBarProps {
  current: number;
  total: number;
}

interface InsightCardProps {
  title: string;
  primaryMetric: number | string;
  supportingText?: string;
  progressBar?: ProgressBarProps;
  onClick?: () => void;
}

const InsightCard = ({
  title,
  primaryMetric,
  supportingText,
  progressBar,
  onClick,
}: InsightCardProps) => {
  const isClickable = Boolean(onClick);
  const percentage = progressBar
    ? progressBar.total > 0
      ? Math.min(Math.round((progressBar.current / progressBar.total) * 100), 100)
      : 0
    : null;

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (onClick && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={`${styles.card} ${isClickable ? styles.card_clickable : ""}`}
      onClick={onClick}
      onKeyDown={isClickable ? handleKeyDown : undefined}
      role={isClickable ? "button" : undefined}
      tabIndex={isClickable ? 0 : undefined}
      aria-label={isClickable ? `${title} — click to view details` : undefined}
    >
      <h3 className={styles.card_title}>{title}</h3>
      <div className={styles.card_metric}>{primaryMetric}</div>
      {supportingText && (
        <p className={styles.card_supporting}>{supportingText}</p>
      )}
      {progressBar && percentage !== null && (
        <div className={styles.card_progress_container}>
          <div
            className={styles.card_progress_bar}
            role="progressbar"
            aria-valuenow={progressBar.current}
            aria-valuemin={0}
            aria-valuemax={progressBar.total}
            aria-label="Installed"
          >
            <div
              className={styles.card_progress_fill}
              style={{ width: `${percentage}%` }}
            />
          </div>
          <span className={styles.card_progress_label}>
            {progressBar.current} / {progressBar.total}
          </span>
        </div>
      )}
    </div>
  );
};

export default InsightCard;
